/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Archive_Description_IntroInputs */

const fr_vehicle_action_archive_description_intro = /** @type {(inputs: Vehicle_Action_Archive_Description_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un véhicule peut être archivé pour les raisons suivantes :`)
};

const en_vehicle_action_archive_description_intro = /** @type {(inputs: Vehicle_Action_Archive_Description_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A vehicle may be archived for the following reasons:`)
};

/**
* | output |
* | --- |
* | "A vehicle may be archived for the following reasons:" |
*
* @param {Vehicle_Action_Archive_Description_IntroInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_archive_description_intro = /** @type {((inputs?: Vehicle_Action_Archive_Description_IntroInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Archive_Description_IntroInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_archive_description_intro(inputs)
	return en_vehicle_action_archive_description_intro(inputs)
});